import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "about";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
